import React from "react";
import AllRoles from "../component/sections/roles/AllRoles";
import AddRole from "../component/sections/roles/AddRole";
import EditRole from "../component/sections/roles/EditRole";
import middleware from "./middlewares/middleware";

const roleRoutes = [
  {
    path: "/roles/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllRoles />,
        "AllRoles"
      );
    },
    exact: true,
  },
  {
    path: "/roles/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddRole />,
        "AddRole"
      );
    },
    exact: true,
  },
  {
    path: "/roles/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditRole />,
        "EditRole"
      );
    },
    exact: true,
  },
];

export default roleRoutes;
